import type { ReactNode } from 'react';
import { Card } from '@/components/ui/Card';
import { errStatus } from '@/components/kit/data';

export interface TimetableRow { id: number; subject: string | null; teacher: string | null; weekday: number; day: string | null; period: number; starts_at: string; ends_at: string; room: string | null; kind: string | null; class?: string | null }

export const DAYS = ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const todayIso = () => { const d = new Date().getDay(); return d === 0 ? 7 : d; };

/** 403 from the student API means "not in an active class" (e.g. alumni) — explain instead of showing a raw error. */
export function NotInClass({ error, children }: { error: unknown; children: ReactNode }) {
  if (errStatus(error) === 403) {
    return <Card><p className="text-sm text-slate-600">This section is only for students currently in a class. Former students can still view results and request documents.</p></Card>;
  }
  return <>{children}</>;
}

export const newKey = () => (globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
